export const CONTACT_SUBSCRIPTION_TYPE_TRANSACTIONAL = 'transactional';
export const CONTACT_SUBSCRIPTION_TYPE_MARKETING = 'marketing';

export const CONTACT_SUBSCRIPTION_STATUS_OPT_IN = 'opt_in';
export const CONTACT_SUBSCRIPTION_STATUS_OPT_OUT = 'opt_out';
export const CONTACT_SUBSCRIPTION_STATUS_UNKNOWN = 'unknown';

export const types = {
    [CONTACT_SUBSCRIPTION_TYPE_TRANSACTIONAL]: 'Transactional',
    [CONTACT_SUBSCRIPTION_TYPE_MARKETING]: 'Marketing',
};

export const statuses = {
    [CONTACT_SUBSCRIPTION_STATUS_OPT_IN]: 'Opted In',
    [CONTACT_SUBSCRIPTION_STATUS_OPT_OUT]: 'Opted Out',
    [CONTACT_SUBSCRIPTION_STATUS_UNKNOWN]: 'No Preference',
} as const;

export type SubscriptionStatus = keyof typeof statuses;

export const subscriptionStatusForSelect = () => {
    return Object.entries(statuses).map(([key, value]) => ({
        label: value,
        value: key,
    }));
};
